import React from "react";
import { useQuery } from "react-query-legacy";
import { BillingEngineService } from "services";
import { AutoComplete, Input } from "antd";
import { useDebounce } from "components/ratecard/hooks";
import { Organization } from "@secondcloset/types/src/_common";
import { SearchOutlined } from "@ant-design/icons";
import colors from "css/colors";
import { AutoCompleteProps } from "antd/lib/auto-complete";

interface OrganizationSearchbar extends Omit<AutoCompleteProps, "onSelect"> {
  onSelect: (organization?: Organization) => void;
}

interface OrganizationOption extends Organization {
  value: string;
}

function OrganizationsSearchbar({ onSelect, value, ...rest }: OrganizationSearchbar) {
  const [search, setSearch] = React.useState("");
  const deboucedSearch = useDebounce(search, 500);

  const { data = [] } = useQuery<Organization[], any>(
    ["organizations", deboucedSearch],
    BillingEngineService.getOrganizations,
    {
      retry: false,
    }
  );

  const onSearch = (value: string) => {
    setSearch(value || "");

    // onClear
    if (value === "") {
      onSelect(undefined);
    }
  };

  function handleSelect(_: any, option: any) {
    const matchingOrg = data.find((org) => org.id === option.id);

    if (matchingOrg) {
      onSelect(matchingOrg);
    }
  }

  const options: any[] = data.map((org: Organization) => {
    return {
      id: org.id,
      value: org.name,
    };
  });

  return (
    <AutoComplete options={options} onSearch={onSearch} onSelect={handleSelect} allowClear {...rest}>
      <Input
        prefix={<SearchOutlined style={{ marginRight: "8px", color: colors.GREY_DARK }} />}
        placeholder="Search Organizations"
      />
    </AutoComplete>
  );
}

export default OrganizationsSearchbar;
